/**
 * API Base URL
 * Priority:
 * 1. REACT_APP_API_URL environment variable
 * 2. Same origin /api (for production deployments on same server)
 * 3. localhost:5000/api (fallback for development)
 */
const getApiUrl = () => {
  // Priority 1: Use environment variable if set
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }

  // Priority 2: If running in browser, use same origin
  if (typeof window !== 'undefined') {
    return `${window.location.origin}/api`;
  }

  // Priority 3: Fallback for server-side rendering or build time
  return 'http://localhost:5000/api';
};

export const API_URL = getApiUrl();

// Log API URL in development for debugging only
if (process.env.NODE_ENV === 'development') {
  console.log('🔗 API_URL configured as:', API_URL);
}
